/** Фасети меню типу запису: лічильники за статусами та за полями груп «за значеннями поля». */
import { useMemo } from 'react';
import { useGetFacetsQuery, useGetStatsQuery } from '@platform/state/api';
import type { IRecordTypeDefinition, IStatBucket } from '@platform/core/types';
import { useCanQueryPii } from '../fields/useCanQueryPii';
import { menuFacetFields } from './menuFacetFields';

const NO_FIELDS: string[] = [];

/**
 * Фасети для buildMenu: `status` — статистика за статусами (порожня, доки вантажиться), поля груп byField — один запит статистики на поле
 * (menuFacetFields). Поля, статистика яких ще вантажиться чи не вдалася, у фасетах відсутні: меню показує їхні варіанти без лічильників.
 * Ті самі аргументи, що й у меню, — спільний кеш RTK Query для лівого меню, сторінки списку й огляду. Поля з персональними даними
 * групує лише Owner/Admin (useCanQueryPii; іншим сервер відмовляє) — для решти їх статистику не запитуємо.
 */
export function useMenuFacets(ws: string, rt: IRecordTypeDefinition | undefined): Record<string, IStatBucket[]> {
  const pii = useCanQueryPii(ws);
  const fields = useMemo(() => (rt ? menuFacetFields(rt).filter((key) => pii || !rt.fields.find((f) => f.key === key)?.pii) : NO_FIELDS), [rt, pii]);
  const { data: status } = useGetStatsQuery({ ws, rt: rt?.key ?? '', by: 'status', params: {} }, { skip: !rt });
  const { data: byField } = useGetFacetsQuery({ ws, rt: rt?.key ?? '', fields }, { skip: !rt || fields.length === 0 });
  return useMemo(() => ({ ...byField, status: status?.buckets ?? [] }), [byField, status]);
}
